import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { LogDto } from '@coin/importer/dto/util';
import { MatInput } from '@angular/material/input';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'importer-import-decision',
  templateUrl: './import-decision.component.html',
  styleUrls: ['./import-decision.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatInput, DatePipe]
})
export class ImportDecisionComponent {
  public readonly data = input<LogDto>(undefined);

  decision = computed(() => this.data()?.decision);
}
